export default {

  install: (Vue) => {
    Vue.prototype.dialog = {

      alert (message) {
        return new Promise((resolve, reject) => {
          Event.$emit('showModal', message)
          Event.$on('showModal', () => {
            resolve()
          })
        })
      },

      confirm ({message, okText, koText, koStyle}) {
        return new Promise((resolve, reject) => {
          Event.$emit('showConfirm', {message, okText, koText, koStyle})
          Event.$on('closeConfirm', accept => {
            if (accept) {
              resolve(accept)
            } else {
              reject(message)
            }
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dialog.js